<div class="not_found">
    <div class="container">
        <div class="row row_ai_center row_jc_center">
            <div class="content">
                <h1 class="main_title margin_bottom">404</h1>
                <div class="row row_ai_center"><h2 class="sub_title">Ой-ой, кто-то нажал не ту кнопку!</h2><img width="38" height="38" src="/assets/icons/smile.svg" alt="smile"></div>
                <p class="text fz_l margin_bottom">Ты нашёл секретное место, где ничего нет. Ну, почти... Вернись на главную и сделай вид, что так и было задумано.
                </p>
                <button class="btn dark_btn" (click)="redirectToHome()">Главная</button>
                <button class="btn dark_btn" (click)="throwIssue()">Тестовая кнопка</button>
            </div>
        </div>
    </div>
</div>